const map = new Map([
  [
    "tax.jinqixin.xyz",
    {
      platfromName: "金启鑫",
      recordNumber: "苏ICP备2025207172号-1",
      logPhoto: "https://qiying-web-static.oss-cn-hangzhou.aliyuncs.com/oemtaxlogo/jqx-logphoto.png",
      systemPhoto: "https://qiying-web-static.oss-cn-hangzhou.aliyuncs.com/oemtaxlogo/jqx-systemPhoto.png"
    }
  ],
  [
    "tax.tlmilaimi.cn",
    {
      platfromName: "泰良米来米",
      recordNumber: "赣ICP备2025070455号",
      iconPhoto: "https://qiying-web-static.oss-cn-hangzhou.aliyuncs.com/oemtaxlogo/tlmlm-icon.png",
      logPhoto: "https://qiying-web-static.oss-cn-hangzhou.aliyuncs.com/oemtaxlogo/tlmlm-logphoto.png",
      systemPhoto: "https://qiying-web-static.oss-cn-hangzhou.aliyuncs.com/oemtaxlogo/tlmlm-systemPhoto.png"
    }
  ],
  [
    "tax.hongtaitop.com",
    {
      platfromName: "鸿泰",
      recordNumber: "豫ICP备2026004961号-1",
      iconPhoto: "https://qiying-web-static.oss-cn-hangzhou.aliyuncs.com/oemtaxlogo/th_icon.png",
      logPhoto: "https://qiying-web-static.oss-cn-hangzhou.aliyuncs.com/oemtaxlogo/th_icon.png",
      systemPhoto: "https://qiying-web-static.oss-cn-hangzhou.aliyuncs.com/oemtaxlogo/th_icon.png"
    }
  ],
  [
    "hexin.xingweitax.cn",
    {
      platfromName: "星为智能",
      recordNumber: "皖ICP备2024062256号",
      iconPhoto: "https://qiying-web-static.oss-cn-hangzhou.aliyuncs.com/oemtaxlogo/xwzn_logo.jpg",
      logPhoto: "https://qiying-web-static.oss-cn-hangzhou.aliyuncs.com/oemtaxlogo/xwzn_logo.jpg",
      systemPhoto: "https://qiying-web-static.oss-cn-hangzhou.aliyuncs.com/oemtaxlogo/xwzn_logo.jpg"
    }
  ]
]);

export const oemFilter = v => {
  const host = window.location.host;
  if (map.has(host)) {
    return {
      ...v,
      ...map.get(host)
    };
  } else {
    return v;
  }
};
